import { createI18n } from "@ecliptica/i18n";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import pt from "./pt.json";

// O backoffice não tem a língua no endereço: deteta (?lang=, escolha guardada, navegador), mas só entre as
// línguas ATIVAS (ACTIVE_LANGS) — hoje só EN, por isso fica sempre em inglês e o botão de língua não aparece.
// Os textos de UI continuam a ser escritos em PT e EN. (O editor de cartas edita os textos PT e EN das CARTAS: é conteúdo, não a língua da UI.)
export const i18n = createI18n({ pt, en }, { detector: LanguageDetector });
